import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Link, Outlet } from "@tanstack/react-router";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: () => <Outlet />,
  notFoundComponent: () => (
    <div className="flex h-full flex-col items-center justify-center gap-2">
      <p className="text-muted-foreground">Page not found.</p>
      <Link to="/" className="text-primary underline">
        Go home
      </Link>
    </div>
  ),
});
